<script lang="ts">
    import type * as t from "~/types";
    import { cn } from "~/utils";
    import TextOptionButton from "./OptionButton__Text.svelte";
    import BackgroundUImageOptionButton from "./OptionButton__BackgroundImage.svelte";
    import { fly } from "svelte/transition";

    export let step: t.MultipleChoiceStep;
    export let visible: boolean;
    export let orientation: "portrait" | "landscape";
</script>

<div
    class={cn(
        (step.optionType === "text_only" || step.optionType === "icon") &&
            "flex size-full max-w-[448px] flex-col justify-center gap-6",

        step.optionType === "background_image" &&
            "mx-auto grid grid-cols-2 gap-4 sm:gap-6",

        step.optionType === "background_image" &&
            orientation === "landscape" &&
            "max-w-[60%]",
    )}
>
    {#each step.options as option, idx (option.title)}
        {#if visible}
            <div transition:fly={{ y: 24, delay: 350 + idx * 350 }}>
                {#if step.optionType === "text_only" || step.optionType === "icon"}
                    <TextOptionButton {option} />
                {:else if step.optionType === "background_image"}
                    <BackgroundUImageOptionButton
                        {option}
                        imgObjectFit={step.backgroundImageObjectFit}
                    />
                {/if}
            </div>
        {/if}
    {/each}
</div>
